import Papa from 'papaparse';
import { downloadBlob } from 'admin-panel/utils/download-blob';

export type CsvRow = { [column: string]: string };

export function parseCsvFile(file: File) {
  return new Promise<CsvRow[]>((resolve, reject) => {
    Papa.parse<CsvRow>(file, {
      header: true,
      skipEmptyLines: true,
      complete: ({ data }) => resolve(data),
      error: reject,
    });
  });
}

export function csvFromRows(rows: CsvRow[]) {
  return Papa.unparse(rows, { delimiter: ';', newline: '\n' });
}

export function downloadCsv(csv: string, name: string) {
  return downloadBlob(new Blob([csv], { type: 'text/csv' }), `${name}.csv`);
}
